import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchNotifications } from '@auw/api-client';
import { onAppEvent, useUserStore } from '@auw/stores';

export const notificationKey = (account: string) => ['notifications', account] as const;
export function useNotificationSummary() {
  const account = useUserStore(state => state.user?.userId ?? '');
  return useQuery({
    queryKey: [...notificationKey(account), 'summary'],
    queryFn: () => fetchNotifications(0, false, 1),
    enabled: !!account, refetchInterval: 5000, refetchIntervalInBackground: true,
  });
}
export function useNotificationInvalidation(): void {
  const client = useQueryClient();
  const account = useUserStore(state => state.user?.userId ?? '');
  useEffect(() => onAppEvent('notifications:changed', () => {
    void client.invalidateQueries({ queryKey: notificationKey(account) });
  }), [account, client]);
}

